import {currentDateEcuador} from "./daysOptions";
import {LocationAddressInterface} from "../services/interface/query/location-address-interface";

export function getLocation(location: LocationAddressInterface | undefined) {
    if (location) {
        return `${location.pais ? location.pais : '-'} ${location.prov ? location.prov : '-'} ${location.cant ? location.cant : '-'} ${location.parr ? location.parr : '-'} ${location.streetName ? location.streetName : '-'}`
    }
    return '-'
}

export function getAge(date: string | undefined | Date) {
    if (date) {
        const dateEcuador = currentDateEcuador()
        let dateBirth
        if (date instanceof Date) {
            dateBirth = date
        } else {
            dateBirth = new Date(date)
        }
        let age = dateEcuador.getFullYear() - dateBirth.getFullYear();
        const currentMonth = dateEcuador.getMonth();
        const birthMonth = dateBirth.getMonth();

        if (currentMonth < birthMonth || (currentMonth === birthMonth && dateEcuador.getDate() < dateBirth.getDate())) {
            age--;
        }

        return age;
    }
    return '-'
}
